import r1 from "./Image/row1/1.webp"
import r2 from "./Image/row1/2.webp"
import r3 from "./Image/row1/3.webp"
import r4 from "./Image/row1/4.webp"
import r5 from "./Image/row1/5.webp"

import r6 from "./Image/row3/1.webp"
import r7 from "./Image/row3/2.webp"
import r8 from "./Image/row3/3.webp"
import r9 from "./Image/row3/4.webp"
import r10 from "./Image/row3/5.webp"
import r11 from "./Image/row3/6.webp"
import r12 from "./Image/row3/7.webp"
import r13 from "./Image/row3/8.webp"
import r14 from "./Image/row3/9.webp"
import r15 from "./Image/row3/10.webp"
import r16 from "./Image/row3/11.webp"
import r17 from "./Image/row3/12.webp"

import ro1 from "./Image/row2/1.webp"
import ro2 from "./Image/row2/2.webp"
import ro3 from "./Image/row2/3.webp"
import ro4 from "./Image/row2/4.webp"
import ro5 from "./Image/row2/5.webp"
import ro6 from "./Image/row2/6.webp"
import ro7 from "./Image/row2/7.webp"
import ro8 from "./Image/row2/8.webp"
import ro9 from "./Image/row2/9.webp"
import ro10 from "./Image/row2/10.webp"

import ro11 from "./Image/row4/1.webp"
import ro12 from "./Image/row4/2.webp"
import ro13 from "./Image/row4/3.webp"
import ro14 from "./Image/row4/4.webp"
import ro15 from "./Image/row4/5.webp"
import ro16 from "./Image/row4/6.webp"
import ro17 from "./Image/row4/7.webp"
import ro18 from "./Image/row4/8.webp"
import ro19 from "./Image/row4/9.webp"
import ro20 from "./Image/row4/10.webp"
import ro21 from "./Image/row4/11.webp"
import ro22 from "./Image/row4/12.webp"
import ro23 from "./Image/row4/13.webp"
import ro24 from "./Image/row4/14.webp"
import ro25 from "./Image/row4/15.webp"
import ro26 from "./Image/row4/16.webp"

import l2 from "./Image/latest/2.webp"
import l4 from "./Image/latest/4.webp"
import l5 from "./Image/latest/5.webp"
import l7 from "./Image/latest/7.webp"
import l10 from "./Image/latest/10.webp"
import l11 from "./Image/latest/11.webp"

import s1 from "./Image/Season1/1.webp"
import s2 from "./Image/Season1/2.webp"
import s3 from "./Image/Season1/3.webp"
import s4 from "./Image/Season1/4.webp"
import s5 from "./Image/Season1/5.webp"
import s6 from "./Image/Season1/6.webp"
import s7 from "./Image/Season1/7.webp"
import s8 from "./Image/Season1/8.webp"

import t1 from "./Image/Trailer/1.jpg"
import t2 from "./Image/Trailer/2.jpg"
import t3 from "./Image/Trailer/3.jpg"

export const row1=[
{img:r1},
{img:r2},
{img:r3},
{img:r4},
{img:r5},
]

export const row2=[
    {img:ro1},
    {img:ro2},
    {img:ro3},
    {img:ro4},
    {img:ro5},
    {img:ro6},
    {img:ro7},
    {img:ro8},
    {img:ro9},
    {img:ro10},
]

export const row3=[
    {img:r6},
    {img:r7},
    {img:r8},
    {img:r9},
    {img:r10},
    {img:r11},
    {img:r12},
    {img:r13},
    {img:r14},
    {img:r15},
    {img:r16},
    {img:r17}
]

export const row4=[
    {img:ro11},
    {img:ro12},
    {img:ro13},
    {img:ro14},
    {img:ro15},
    {img:ro16},
    {img:ro17},
    {img:ro1},
    {img:ro2},
    {img:ro18},
    {img:ro19},
    {img:ro20},
    {img:ro21},
    {img:ro7},
    {img:ro8},
    {img:ro22},
    {img:ro23},
    {img:ro24},
    {img:ro25},
    {img:ro26},
    {img:ro9},
    {img:ro10},
]

export const latest=[
    {img:ro1,
    t1:"DRAMA",
    t2:"Black Brid",
    t3:"An imprisoned man is offered freedom if he can get a suspected killer to confess."

    },
    {img:l2,
    t1:"KIDS & FAMILY",
    t2:"Duck & Goose",
    t3:"Despite their differences, two feathered friends bring out the best in one another.",
    },
    {img:ro3,
    t1:"COMEDY",
    t2:'Loot',
    t3:'A woman searches for meaning after getting an $87 billion divorce settlement.',
    },
    {img:l4,
    t1:"COMEDY",
    t2:'Cha Cha Real Smooth',
    t3:'A recent college grad forms a unique bond with a young mom and her teen daughter.',
    },
    {img:l5,
    t1:"DOCUMENTARY",
    t2:'Home',
    t3:`A new season invites you to step inside the ${"world's"} most imaginative dwellings.`,
    },
    {img:ro4,
    t1:"DRAMA",
    t2:'For All Mankind',
    t3:'A new competitor joins the global space race in season 3 of the thrilling drama series.',
    },
    {img:l7,
    t1:"KIDS & FAMILY",
    t2:'Lovely Little Farm',
    t3:'Two young sisiters start their very own special farm, where every day is an adventure.',  
    },
    {img:ro7,
    t1:"COMEDY",
    t2:'Physical',
    t3:'Sheila hustles to turn her fitness empire dreams into reality in the second season.',
    },
    {img:ro8,
    t1:"DOCUMENTARY",
    t2:'Prehistoric Planet',
    t3:'An epic series that lets you experience the world of dinosaurs like never before.',
    },
    {img:l10,
    t1:"COMEDY",
    t2:'Carpool Karaoke: The Series',
    t3:'Take a musical ride with the D Amelio family, The White Lotus cast, and more.',
    },
    {img:l11,
    t1:"KIDS & FAMILY",
    t2:'Helpsters',
    t3:'Cody and the team of helpful monsters are back to solve new problems big and small.',
    },
    {img:ro2,
    t1:"DRAMA",
    t2:'Now and Then',
    t3:'Five former friends reunite when a blackmailer threatens to expose their dark secret.',
    },

]

export const ComingSoon=[
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features122/v4/9b/df/2b/9bdf2bba-7166-2887-a39f-6f74bf7f4c8e/6430384a-963d-4000-bbf4-d27e31097120.lsr/1478x832fe.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features112/v4/81/ce/da/81ceda4a-fdff-1d17-bfca-6493507f599a/daa42efb-7e31-4911-ae93-b24b5262709e.lsr/1478x832fe.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/Features122/v4/6e/a6/04/6ea60487-a519-d40c-65cc-e8bbd061f916/8eb1a874-9cf5-453b-b2d4-6a915ff83d76.lsr/1478x832fe.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/Features112/v4/3f/5c/8c/3f5c8cc0-1a6d-bfea-f5aa-6c8a209dcdef/879754b7-d036-4a3c-8f91-6d03eab36885.lsr/1478x832fe.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features122/v4/06/df/c3/06dfc368-4814-ee53-77b2-a5bf3df32aec/4be54ef8-78bf-48fc-b7db-5fee50a03e0e.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features112/v4/67/81/4d/67814dfc-145f-cbd8-4dc8-2c5c9ad8a041/18e44971-c5a4-40c0-9604-830a1c7c5a77.lsr/1478x832fe.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/Features112/v4/6e/9b/3b/6e9b3beb-6d1f-b5e1-e540-564f80fa2245/ac64ee88-ee90-46c0-85b2-e095add547e0.lsr/1478x832fe.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features112/v4/ce/37/ad/ce37ad51-d835-5f84-a845-430d5007ada8/ee565457-5034-4208-b551-0a33ec1e0b23.lsr/1478x832fe.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features122/v4/c3/40/9c/c3409c6a-036c-4827-513c-fe9904d6b752/ceb89685-1a73-434a-a77c-c37b52a11bce.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features122/v4/41/7e/13/417e13c5-616f-4c43-4da2-846d5c980e15/8df68cfc-38e3-4706-9395-f6b6646cecef.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features122/v4/10/4c/18/104c18fc-6e00-c3e5-edce-2e3e28ce0c31/88c6fd80-8426-44d1-889f-0d58494db03a.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features112/v4/6c/db/44/6cdb443b-c1c6-11af-47be-0ffd8f839904/9274fc7e-0d0e-4912-b5f4-ba32d7115323.lsr/1478x832fe.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features116/v4/45/6e/b2/456eb26a-fd01-665d-ddaa-60558c888f40/U0YtVFZBLVdXLVJheW1vbmRfQW5kX1JheS1DU19Ccmlja19ub0J1Zy5sc3I.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features112/v4/fe/dd/51/fedd5169-db23-fe26-5388-2dccfca3f8bf/VTBZdFZGWkJMVmRYTFZOd2FYSnBkR1ZrTFVOVExVSnlhV05yWDI1dlFuVm5MbXh6Y2cubHNy.lsr/1478x832fe.webp"},

]

export const baseball=[
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features116/v4/fe/30/99/fe30991b-023f-65db-6c47-9bcaacab5977/90310982-ea94-40a5-81e4-9d8de34c261e.lsr/1478x832fe.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features126/v4/f4/0a/4a/f40a4ac5-1d02-811d-f16b-9f5516fb7156/e42ffec9-d624-47fc-8dba-674142619205.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features116/v4/43/bb/de/43bbde5e-e7df-6f87-47ff-7cdfc211dc21/b07c188b-e1a2-4020-a4fc-c3fa00aa22d8.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features126/v4/9a/31/b3/9a31b32d-49b2-883c-4980-d21c4a54ca61/99152498-54bf-4672-a902-6b6785530333.lsr/1478x832fe.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features126/v4/e2/3b/69/e23b6978-fc88-161d-ccbc-1d9cb58c7037/533471c3-b683-43aa-9392-f8aac00eef66.lsr/1478x832fe.webp"},
]

export const SingleSlide1=[
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features122/v4/76/52/f0/7652f065-0ea4-b8c8-acd7-f29b26a835eb/0267c2f7-5054-42d4-a259-aa62cc41a153.png/1320x495sr.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Features122/v4/44/75/a8/4475a8d3-b6c3-cba4-3707-54b4f90c5052/669928d8-da1f-40eb-af64-cb36ee147884.png/1320x495sr.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Features122/v4/2b/bd/72/2bbd7285-751d-fc5a-51dd-de22492315a7/b9ff2dd4-f975-47cf-b113-53086ffd2dd0.png/1320x495sr.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features122/v4/e3/41/94/e341949a-9035-2d6c-a866-d7b25dc4a877/7ae0e092-d32f-4039-891b-e9543af3cb2a.png/1320x495sr.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Features122/v4/e8/5b/66/e85b6645-b433-eee0-51d7-750786163778/c580c2c3-7310-440c-97af-764b52d081bc.png/1320x495sr.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features122/v4/b3/ba/74/b3ba7420-6073-ca36-71bb-1deeda1e6080/25a3c2a4-6652-4137-8cea-cd258c634f4d.png/1319x494sr.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Features122/v4/3f/6b/78/3f6b789e-ef38-5ec8-5406-e40b04921200/4f195c28-9fa0-4704-b0dd-e1a75f50dac5.png/1320x495sr.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features112/v4/6c/55/40/6c5540ba-fcff-a0e1-7a93-276a0f79297d/7aae0802-f405-4629-9da7-59da9b4e509a.png/1320x495sr.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features122/v4/34/f4/ea/34f4ea56-4836-164e-1424-481b65a72e0e/d2122db0-68ea-423d-ad0d-71779e927b5f.png/1320x495sr.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/Features122/v4/30/8c/1b/308c1bdb-c1c7-fa4f-33d1-08065907d59f/e0e6538f-f6d0-467f-816e-077180a1e041.png/1320x495sr.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Features122/v4/15/8a/72/158a7265-3276-c9f5-899b-5d40fdbd245d/c63e2078-242a-42bd-85b5-7f119518e6d0.png/1320x495sr.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Features122/v4/7f/85/aa/7f85aadb-a9e8-6dcf-1089-06505b661303/e20841f4-20a0-49e6-a8f3-d40c1487c5b2.png/1320x495sr.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features122/v4/28/64/e9/2864e982-e150-23d1-fa8d-4224a8523c79/ccfffb6e-a8b2-4675-bdf4-c45a445edf99.png/1320x495sr.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features112/v4/3a/72/f0/3a72f069-cd1f-800c-9a41-f009c67ae646/d89fd758-8997-4b2e-9e02-f472720198b2.png/1320x495sr.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features122/v4/02/df/97/02df9769-b6da-99cc-22ca-10b2f07f1a7f/bd117faa-2f63-48b0-9428-a6bb93b36cd5.png/1320x495sr.webp"},
    

]

export const Suspense=[
    {img:ro15},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Ro6cUnMcHLf3sEVL38YlRg/738x416.webp"},
    {img:ro17},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Iz8wdsRXYRysnRRCY0yMrA/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/XiXPs1AKOFQE7cq7AVlJeQ/738x416.webp"},
    {img:ro1},
    {img:ro13},
    {img:ro5},
]

export const Sensational=[
    {img:"https://is2-ssl.mzstatic.com/image/thumb/SEsiWD2cTDShiJqUtRPAxg/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/lN-bUPh0Botn7U7jKgbnFg/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/5SQrBAWXONSSRweUSmuRyg/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/IryLNqf3vJszRupPX70Elg/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/rZ34KsuVSjdutVP-0HO95A/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/neRAWaMZZ5xVz4fnbFXJUA/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/2hSgeI8AyyKcpu_6Rhwg1w/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/AWDRdQz0nepFpnsUNiTDuw/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/eGnsZyr_h0ivXT0r4jbaew/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/EjmCDwq97jEEe9RuKY7aNw/738x416.webp"},
]

export const Moment=[
    {img:"https://is2-ssl.mzstatic.com/image/thumb/GT66HoV8VJL1IZwaqos_TQ/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/VXktJkcnADdcq8RjZVT_nw/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/McXcp2YSeuDh16Oph0nt6g/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/zRCSBlp0LjwClRXsjyDNYQ/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/IyvoDdhWEjtSADaSryepIw/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Epzt9WNlE21aE-FNCoVj2w/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/dbEKo7rp5RGNNDrCbA7AUQ/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/DCj5c2CndQsWCj9zkGGa5Q/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/eGnsZyr_h0ivXT0r4jbaew/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/D8bOyY8jg5hymGMxt1LSZg/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/_ODFuW8DJbcFSHL_yhHuVA/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Ru8FEVLXR20CLzgnt9UXOQ/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/3iAbZQ4pznOpDRenkvOhNA/738x416.webp"},
]

export const Science=[
    {img:"https://is2-ssl.mzstatic.com/image/thumb/78-I7VenST4ztZYfwMf6AQ/1478x832.webp",
      t1:"THRILLETR",
      t2:"Severance",
      t3:"Adam Scott stars i nthis darkly gripping series from director Ben Stiller.",  
    },
    {img:"https://is1-ssl.mzstatic.com/image/thumb/kjrFHClZ3Bt-pT0MJnwdFw/1478x832.webp",
      t1:"DRAMA",
      t2:'For All Mankind',
      t3:'A new competitor joins the global space race in season 3 of the thrilling drama series.', 
    },
    {img:"https://is3-ssl.mzstatic.com/image/thumb/NcMcLMcSxa5Ho_oOXvUbGg/1478x832.webp",
      t1:"DRAMA",
      t2:"See",
      t3:"A future without sight is challenged by twins born with the mythic ability to see.",  
    },
    {img:"https://is5-ssl.mzstatic.com/image/thumb/NHLksWLSZpTcIw36-n7vWA/1478x832.webp",
      t1:"SCI-FI",
      t2:"Invasion",
      t3:"An alien species arrives--see it through the lens of five lives across the globe.",  
    },
    {img:"https://is2-ssl.mzstatic.com/image/thumb/qYEYYvFXN2O4zEuCcBSbjw/1478x832.webp",
      t1:"SCI-FI",
      t2:"Foundation",
      t3:"Amid the fall of the Galactic Empire a band of exiles fights to save humanity.",  
    },
    {img:"https://is4-ssl.mzstatic.com/image/thumb/vWs6dt5xDhG_DjIoc-89tA/1478x832.webp",
      t1:"COMEDY",
      t2:"Mythic Quest",
      t3:"The biggest multiplayer video game in the world has major action behind the scenes.",  
    },
]

export const Comedy=[
    {img:"https://is1-ssl.mzstatic.com/image/thumb/IyvoDdhWEjtSADaSryepIw/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/GT66HoV8VJL1IZwaqos_TQ/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/y-GzfKyC0y6x5Dd8254GpQ/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/neRAWaMZZ5xVz4fnbFXJUA/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/vWs6dt5xDhG_DjIoc-89tA/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/dbEKo7rp5RGNNDrCbA7AUQ/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/RHDyosPjHXJc01IiulkQSg/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/rZ34KsuVSjdutVP-0HO95A/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/le6mxqLNaXH47MHIH7stzw/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/3iAbZQ4pznOpDRenkvOhNA/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/eGnsZyr_h0ivXT0r4jbaew/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/D8bOyY8jg5hymGMxt1LSZg/738x416.webp"},
]


export const Drama=[
    {img:"https://is2-ssl.mzstatic.com/image/thumb/WTDZpzkQlaatpb1X4w9jZg/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/kjrFHClZ3Bt-pT0MJnwdFw/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/78-I7VenST4ztZYfwMf6AQ/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/XiXPs1AKOFQE7cq7AVlJeQ/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/AWDRdQz0nepFpnsUNiTDuw/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/NcMcLMcSxa5Ho_oOXvUbGg/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/fiTyznFr4Rsvd25TNhffww/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/lN-bUPh0Botn7U7jKgbnFg/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/QiFf4rD5DY65HbtJUOjE7Q/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/2hSgeI8AyyKcpu_6Rhwg1w/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/SEsiWD2cTDShiJqUtRPAxg/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/kVTKGnVvCdFlB1sZeKa8YQ/738x416.webp"},
]

export const Feature=[
    {img:"https://is5-ssl.mzstatic.com/image/thumb/McXcp2YSeuDh16Oph0nt6g/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/zRCSBlp0LjwClRXsjyDNYQ/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/8593WFOGVTTA1ncIGrL37g/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/cyRvgYnPlaVn3rN2SDdW1Q/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/k-4X4dDwJrtXlsgr1VI_0w/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/xwiVfxV1l5Tfy6-1uQ25_Q/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/oANBVngpEJDvHRhdyozySA/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Epzt9WNlE21aE-FNCoVj2w/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/D1SCGzM1ESBh-SIkHwcvUQ/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/fS85BR5uGUlTFLXLAWAMsg/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/DCj5c2CndQsWCj9zkGGa5Q/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/KdlcNbBUOtf7sUXH5z9N8A/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/K-nsm8mEVNAAnevMTyya7g/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/CwpcQl754x9lwddZ9TXqmQ/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/2kwDdUMkGYVufGBF3g1hdA/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/jvpbfkNAZaLIN3DZJUDX8Q/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/CurGU6004wvloeDxunoxyA/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/jbuAq3KUPjh27XucTemVxg/738x416.webp"},
]

export const Kids=[
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features122/v4/b5/f1/2e/b5f12ecf-bea3-9f40-a3f4-2b9660fa0171/6343fb11-36eb-4ccf-867f-926f0ff57529.lsr/1478x832fe.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/Features122/v4/91/34/93/91349390-2352-3646-571d-03d259cd942c/fd2a72bc-ccfa-410b-914e-e907052c7b48.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features122/v4/2c/6f/1a/2c6f1a43-c21a-4dc3-a6bc-65eeda7ad8e0/8fb1cbae-88fc-44fc-a95a-18973a6f2699.lsr/1478x832fe.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features122/v4/a2/75/fd/a275fdcd-be55-6ac1-0fe9-8a7e1490a6a9/b7106e74-e839-47ef-84a6-e5c258e2f401.lsr/1478x832fe.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Features122/v4/e7/74/b7/e774b707-f280-acb6-0426-d1ab1c773c5c/ea0cc30a-4027-4e6a-a733-24db0cef2ab0.lsr/1478x832fe.webp"},
   
]

export const searchShow=[

    {img:ro2},
    {img:ro3},
    {img:ro4},
    {img:ro5},
    {img:ro7},
    {img:ro8},
    {img:ro9},
    {img:ro10},
    {img:ro1},
    {img:r7},
    {img:r8},
    {img:r9},
    {img:r10},
    {img:r11},
    {img:r12},
    {img:r13},
    {img:r14},
    {img:r15},
    {img:r16},
    {img:r17},
    {img:ro11},
    {img:ro12},
    {img:ro13},
    {img:ro14},
    {img:ro15},
    {img:ro16},
    {img:ro17},
    {img:ro18},
    {img:ro19},
    {img:ro20},
    {img:ro21},
    {img:ro22},
    {img:ro23},
    {img:ro24},
    {img:ro25},
    {img:ro26},
    {img:l2},
    {img:l4},
    {img:l5},
    {img:l7},
    {img:l10},
    {img:l11},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features122/v4/9b/df/2b/9bdf2bba-7166-2887-a39f-6f74bf7f4c8e/6430384a-963d-4000-bbf4-d27e31097120.lsr/1478x832fe.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features112/v4/81/ce/da/81ceda4a-fdff-1d17-bfca-6493507f599a/daa42efb-7e31-4911-ae93-b24b5262709e.lsr/1478x832fe.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/Features122/v4/6e/a6/04/6ea60487-a519-d40c-65cc-e8bbd061f916/8eb1a874-9cf5-453b-b2d4-6a915ff83d76.lsr/1478x832fe.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/Features112/v4/3f/5c/8c/3f5c8cc0-1a6d-bfea-f5aa-6c8a209dcdef/879754b7-d036-4a3c-8f91-6d03eab36885.lsr/1478x832fe.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/Features122/v4/06/df/c3/06dfc368-4814-ee53-77b2-a5bf3df32aec/4be54ef8-78bf-48fc-b7db-5fee50a03e0e.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features112/v4/67/81/4d/67814dfc-145f-cbd8-4dc8-2c5c9ad8a041/18e44971-c5a4-40c0-9604-830a1c7c5a77.lsr/1478x832fe.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/Features112/v4/6e/9b/3b/6e9b3beb-6d1f-b5e1-e540-564f80fa2245/ac64ee88-ee90-46c0-85b2-e095add547e0.lsr/1478x832fe.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features112/v4/ce/37/ad/ce37ad51-d835-5f84-a845-430d5007ada8/ee565457-5034-4208-b551-0a33ec1e0b23.lsr/1478x832fe.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features122/v4/c3/40/9c/c3409c6a-036c-4827-513c-fe9904d6b752/ceb89685-1a73-434a-a77c-c37b52a11bce.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features122/v4/41/7e/13/417e13c5-616f-4c43-4da2-846d5c980e15/8df68cfc-38e3-4706-9395-f6b6646cecef.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features122/v4/10/4c/18/104c18fc-6e00-c3e5-edce-2e3e28ce0c31/88c6fd80-8426-44d1-889f-0d58494db03a.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features112/v4/6c/db/44/6cdb443b-c1c6-11af-47be-0ffd8f839904/9274fc7e-0d0e-4912-b5f4-ba32d7115323.lsr/1478x832fe.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Features116/v4/45/6e/b2/456eb26a-fd01-665d-ddaa-60558c888f40/U0YtVFZBLVdXLVJheW1vbmRfQW5kX1JheS1DU19Ccmlja19ub0J1Zy5sc3I.lsr/1478x832fe.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Features112/v4/fe/dd/51/fedd5169-db23-fe26-5388-2dccfca3f8bf/VTBZdFZGWkJMVmRYTFZOd2FYSnBkR1ZrTFVOVExVSnlhV05yWDI1dlFuVm5MbXh6Y2cubHNy.lsr/1478x832fe.webp"},

    {img:"https://is4-ssl.mzstatic.com/image/thumb/Ro6cUnMcHLf3sEVL38YlRg/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/Iz8wdsRXYRysnRRCY0yMrA/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/XiXPs1AKOFQE7cq7AVlJeQ/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/SEsiWD2cTDShiJqUtRPAxg/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/lN-bUPh0Botn7U7jKgbnFg/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/5SQrBAWXONSSRweUSmuRyg/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/IryLNqf3vJszRupPX70Elg/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/rZ34KsuVSjdutVP-0HO95A/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/neRAWaMZZ5xVz4fnbFXJUA/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/2hSgeI8AyyKcpu_6Rhwg1w/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/AWDRdQz0nepFpnsUNiTDuw/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/eGnsZyr_h0ivXT0r4jbaew/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/EjmCDwq97jEEe9RuKY7aNw/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/GT66HoV8VJL1IZwaqos_TQ/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/VXktJkcnADdcq8RjZVT_nw/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/McXcp2YSeuDh16Oph0nt6g/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/zRCSBlp0LjwClRXsjyDNYQ/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/IyvoDdhWEjtSADaSryepIw/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Epzt9WNlE21aE-FNCoVj2w/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/dbEKo7rp5RGNNDrCbA7AUQ/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/DCj5c2CndQsWCj9zkGGa5Q/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/eGnsZyr_h0ivXT0r4jbaew/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/D8bOyY8jg5hymGMxt1LSZg/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/_ODFuW8DJbcFSHL_yhHuVA/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/Ru8FEVLXR20CLzgnt9UXOQ/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/3iAbZQ4pznOpDRenkvOhNA/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/78-I7VenST4ztZYfwMf6AQ/1478x832.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/kjrFHClZ3Bt-pT0MJnwdFw/1478x832.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/NcMcLMcSxa5Ho_oOXvUbGg/1478x832.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/NHLksWLSZpTcIw36-n7vWA/1478x832.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/qYEYYvFXN2O4zEuCcBSbjw/1478x832.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/vWs6dt5xDhG_DjIoc-89tA/1478x832.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/IyvoDdhWEjtSADaSryepIw/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/GT66HoV8VJL1IZwaqos_TQ/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/y-GzfKyC0y6x5Dd8254GpQ/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/neRAWaMZZ5xVz4fnbFXJUA/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/vWs6dt5xDhG_DjIoc-89tA/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/dbEKo7rp5RGNNDrCbA7AUQ/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/RHDyosPjHXJc01IiulkQSg/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/rZ34KsuVSjdutVP-0HO95A/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/le6mxqLNaXH47MHIH7stzw/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/3iAbZQ4pznOpDRenkvOhNA/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/eGnsZyr_h0ivXT0r4jbaew/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/D8bOyY8jg5hymGMxt1LSZg/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/WTDZpzkQlaatpb1X4w9jZg/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/kjrFHClZ3Bt-pT0MJnwdFw/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/78-I7VenST4ztZYfwMf6AQ/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/XiXPs1AKOFQE7cq7AVlJeQ/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/AWDRdQz0nepFpnsUNiTDuw/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/NcMcLMcSxa5Ho_oOXvUbGg/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/fiTyznFr4Rsvd25TNhffww/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/lN-bUPh0Botn7U7jKgbnFg/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/QiFf4rD5DY65HbtJUOjE7Q/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/2hSgeI8AyyKcpu_6Rhwg1w/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/SEsiWD2cTDShiJqUtRPAxg/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/kVTKGnVvCdFlB1sZeKa8YQ/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/McXcp2YSeuDh16Oph0nt6g/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/zRCSBlp0LjwClRXsjyDNYQ/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/8593WFOGVTTA1ncIGrL37g/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/cyRvgYnPlaVn3rN2SDdW1Q/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/k-4X4dDwJrtXlsgr1VI_0w/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/xwiVfxV1l5Tfy6-1uQ25_Q/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/oANBVngpEJDvHRhdyozySA/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/Epzt9WNlE21aE-FNCoVj2w/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/D1SCGzM1ESBh-SIkHwcvUQ/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/fS85BR5uGUlTFLXLAWAMsg/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/DCj5c2CndQsWCj9zkGGa5Q/738x416.webp"},
    {img:"https://is5-ssl.mzstatic.com/image/thumb/KdlcNbBUOtf7sUXH5z9N8A/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/K-nsm8mEVNAAnevMTyya7g/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/CwpcQl754x9lwddZ9TXqmQ/738x416.webp"},
    {img:"https://is4-ssl.mzstatic.com/image/thumb/2kwDdUMkGYVufGBF3g1hdA/738x416.webp"},
    {img:"https://is1-ssl.mzstatic.com/image/thumb/jvpbfkNAZaLIN3DZJUDX8Q/738x416.webp"},
    {img:"https://is3-ssl.mzstatic.com/image/thumb/CurGU6004wvloeDxunoxyA/738x416.webp"},
    {img:"https://is2-ssl.mzstatic.com/image/thumb/jbuAq3KUPjh27XucTemVxg/738x416.webp"},
]


export const S=[
    {img:s1},
    {img:s2},
    {img:s3},
    {img:s4},
    {img:s5},
    {img:s6},
    {img:s7},
    {img:s8},
    
]
export const Season=[
    {img:s1,
      t1:"EPISODE 1",
      t2:"Nikki and Jason",
      t3:"Adam Scott stars i nthis darkly gripping series from director Ben Stiller.",  
    },
    {img:s2,
      t1:"EPISODE 2",
      t2:'The Ex-Girlfriend',
      t3:'A new competitor joins the global space race in season 3 of the thrilling drama series.', 
    },
    {img:s3,
      t1:"EPISODE 3",
      t2:"Tickets for a Queue",
      t3:"A future without sight is challenged by twins born with the mythic ability to see.",  
    },
    {img:s4,
      t1:"EPISODE 4",
      t2:"Rainbow Castle People",
      t3:"An alien species arrives--see it through the lens of five lives across the globe.",  
    },
    {img:s5,
      t1:"EPISODE 5",
      t2:"Someone Else's Kids",
      t3:"Amid the fall of the Galactic Empire a band of exiles fights to save humanity.",  
    },
    {img:s6,
      t1:"EPISODE 6",
      t2:"Show Me the Love",
      t3:"The biggest multiplayer video game in the world has major action behind the scenes.",  
    },
    {img:s7,
        t1:"EPISODE 7",
        t2:"Good Old Family Map",
        t3:"The biggest multiplayer video game in the world has major action behind the scenes.",  
      },
      {img:s8,
        t1:"EPISODE 8",
        t2:"We Know the Way Out",
        t3:"The biggest multiplayer video game in the world has major action behind the scenes.",  
      },
]



export const Casts=[
    {
    img:"https://is2-ssl.mzstatic.com/image/thumb/VHd0ABJvYyKCz_O6j0reHA/492x492ve.webp",
    t1:"Rafe Spall",
    t2:"Jason",
    },
    {
    img:"https://is3-ssl.mzstatic.com/image/thumb/-jk0Ypqjm1y0FnIVlQVs_w/492x492ve.webp",
    t1:"Esther Smith",
    t2:"Nikki",
    },
    {
    img:"https://is3-ssl.mzstatic.com/image/thumb/iRYWvTxTD0CE5ticSmmSmw/492x492ve.webp",
    t1:"Imelda Staunton",
    t2:"Penny",
    },
    {
    img:"https://is4-ssl.mzstatic.com/image/thumb/zWDTe2eQ2GLdYZJBoCk7JQ/492x492ve.webp",
    t1:"Ophelia Lovibond",
    t2:"Erica",
    },
    {
    img:"https://is1-ssl.mzstatic.com/image/thumb/FiHzudymaFDVbT7t0GRDeQ/492x492ve.webp",
    t1:"Oliver Chris",
    t2:"Freddy",
    },
    {
    img:"https://is1-ssl.mzstatic.com/image/thumb/XbRk28cRs1D2s3PjqRxiHg/492x492bb.webp",
    t1:"Sian Brooke",
    t2:"Karen",
    },
    {
    img:"https://is1-ssl.mzstatic.com/image/thumb/rKjYGNrlZOVuChIN-C0m7Q/492x492bb.webp",
    t1:"Darren Boyd",
    t2:"Scott",
    },
    {
    img:"https://is5-ssl.mzstatic.com/image/thumb/8LYbYDFbgejUQXVx0E9Hqw/492x492bb.webp",
    t1:"Andy Wolton",
    t2:"Executive Producer",
    },
    {
    img:"https://is5-ssl.mzstatic.com/image/thumb/KDUw24W3a1Kjw4TQdvhbBg/492x492bb.webp",
    t1:"Jim O'Hanlon",
    t2:"Executive Producer",
    },
    {
    img:"https://is3-ssl.mzstatic.com/image/thumb/Oj4_hBDNRnRycq76awNIdA/492x492bb.webp",
    t1:"Josh Cole",
    t2:"Executive Producer",
    },
    {
    img:"https://is1-ssl.mzstatic.com/image/thumb/4Piz-VlZkUS_VkuJHRGs9Q/492x492bb.webp",
    t1:"Sam Pinnell",
    t2:"Producer",
    },
    {
    img:"https://is4-ssl.mzstatic.com/image/thumb/bSS4Rz6WxHDnuhx7c1dAjQ/492x492ve.webp",
    t1:"Emma Lawson",
    t2:"Producer",
    },
    {
    img:"https://is3-ssl.mzstatic.com/image/thumb/B8Ue_zbC_YyjrXAwzapuRw/492x492bb.webp",
    t1:"Michael Roskam",
    t2:"Executive Producer",
    },
    {
    img:"https://is4-ssl.mzstatic.com/image/thumb/GGMV0kQLZOlvIxvOVrWr8g/492x492bb.webp",
    t1:"Kary Antholis",
    t2:"Producer",
    },
    
    
    
]